import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";
import {IGalleryItem} from "../types/GalleryItem";

type stateType = {
    fetched: boolean;
    loading: boolean;
    items: IGalleryItem[] | null;
}

const initialState: stateType = {
    fetched: false,
    loading: false,
    items: null,
}
export const fetchGallery = createAsyncThunk('gallery/fetchGallery', () => {
    return axios
        .get(`https://php.motokarymartin.sk/gallery/?location=${config.location}`)
        .then((response) => response.data);
});

const gallerySlice = createSlice({
    name: 'gallery',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchGallery.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchGallery.fulfilled, (state, action) => {
            state.fetched = true;
            state.loading = false;
            state.items = action.payload;
        })
        builder.addCase(fetchGallery.rejected, (state, action) => {
            state.loading = false;
            console.error("During fetching of gallery there was an error:", action.error);
        })
    },
});

export default gallerySlice.reducer;